import React from 'react';
import { Shield, Lock, Database, MessageCircle, FileText, ShieldCheck, UserCog, Scale, Mail, Phone } from 'lucide-react';
export function App() {
  return <div className="min-h-screen flex flex-col bg-slate-50" data-id="element-0">
      {/* Header */}
      <header className="bg-slate-900 text-white py-6 px-4 sm:px-6 lg:px-8 shadow-md" data-id="element-1">
        <div className="max-w-4xl mx-auto flex items-center gap-3" data-id="element-2">
          <Shield className="w-8 h-8 text-blue-400" data-id="element-3" />
          <h1 className="text-2xl font-bold tracking-wide" data-id="element-4">
            Vidality Insurance Group
          </h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow py-12 px-4 sm:px-6 lg:px-8" data-id="element-5">
        <article className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-6">
          {/* Document Header */}
          <div className="bg-slate-100 border-b border-slate-200 px-8 py-10 text-center" data-id="element-7">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-slate-200 mb-6" data-id="element-8">
              <Lock className="w-8 h-8 text-slate-700" data-id="element-9" />
            </div>
            <h1 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-10">
              Política de Privacidad y Responsabilidad
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-11">
              Al enviar este formulario, usted acepta los siguientes términos
              establecidos por Vidality Insurance Group.
            </p>
          </div>

          {/* Document Body */}
          <div className="px-8 py-10 space-y-12 text-slate-700 leading-relaxed" data-id="element-12">
            {/* Section 1 */}
            <section data-id="element-13">
              <div className="flex items-center gap-3 mb-4" data-id="element-14">
                <Database className="w-6 h-6 text-blue-700" data-id="element-15" />
                <h2 className="text-2xl font-bold text-slate-900" data-id="element-16">
                  1. Uso de la Información
                </h2>
              </div>
              <div className="pl-9 space-y-4" data-id="element-17">
                <p data-id="element-18">
                  La información proporcionada en este formulario es recopilada
                  exclusivamente por <strong data-id="element-19">Vidality Insurance Group</strong>{' '}
                  con el único propósito de contactarle para ofrecerle una
                  asesoría personalizada y gratuita sobre productos de seguros
                  de vida y planificación financiera.
                </p>
                <div className="bg-blue-50 border-l-4 border-blue-700 p-4 rounded-r-md" data-id="element-20">
                  <p className="text-blue-900 font-medium" data-id="element-21">
                    Sus datos nunca serán vendidos, compartidos ni transferidos
                    a terceros sin su consentimiento expreso.
                  </p>
                </div>
              </div>
            </section>

            {/* Section 2 */}
            <section data-id="element-22">
              <div className="flex items-center gap-3 mb-4" data-id="element-23">
                <MessageCircle className="w-6 h-6 text-blue-700" data-id="element-24" />
                <h2 className="text-2xl font-bold text-slate-900" data-id="element-25">
                  2. Contacto y Comunicación
                </h2>
              </div>
              <div className="pl-9 space-y-4" data-id="element-26">
                <p data-id="element-27">
                  Al completar este formulario, usted autoriza a Vidality
                  Insurance Group y a sus representantes autorizados a
                  contactarle a través de:
                </p>
                <ul className="list-disc pl-5 space-y-2 text-slate-700 marker:text-blue-500" data-id="element-28">
                  <li data-id="element-29">Llamadas telefónicas</li>
                  <li data-id="element-30">Mensajes de texto (SMS)</li>
                  <li data-id="element-31">Correo electrónico</li>
                </ul>
                <p data-id="element-32">
                  con el propósito exclusivo de brindarle información sobre los
                  productos y servicios solicitados.
                </p>
                <p className="text-sm bg-slate-50 p-4 rounded-md border border-slate-100" data-id="element-33">
                  Puede cancelar esta autorización en cualquier momento
                  respondiendo "STOP" a cualquier mensaje de texto o enviando un
                  correo a{' '}
                  <a href="mailto:correo@vitalityinsurancegroup.com" className="text-blue-700 hover:text-blue-800 font-medium underline decoration-blue-300 underline-offset-2" data-id="element-34">
                    correo@vitalityinsurancegroup.com
                  </a>
                  .
                </p>
              </div>
            </section>

            {/* Section 3 */}
            <section data-id="element-35">
              <div className="flex items-center gap-3 mb-4" data-id="element-36">
                <FileText className="w-6 h-6 text-blue-700" data-id="element-37" />
                <h2 className="text-2xl font-bold text-slate-900" data-id="element-38">
                  3. Naturaleza de la Información
                </h2>
              </div>
              <div className="pl-9 space-y-4" data-id="element-39">
                <p data-id="element-40">
                  El contenido presentado en esta página es de carácter
                  educativo e informativo. No constituye asesoría legal, fiscal
                  ni financiera formal.
                </p>
                <p data-id="element-41">
                  Los productos de seguros de vida indexados (IUL) están sujetos
                  a:
                </p>
                <ul className="list-disc pl-5 space-y-2 text-slate-700 marker:text-blue-500" data-id="element-42">
                  <li data-id="element-43">Términos y condiciones de cada compañía aseguradora</li>
                  <li data-id="element-44">
                    Regulaciones estatales vigentes en el estado de residencia
                    del solicitante
                  </li>
                  <li data-id="element-45">Proceso de suscripción y calificación médica</li>
                </ul>
                <p className="italic text-slate-500" data-id="element-46">
                  Los resultados y beneficios varían según el contrato, la
                  compañía, el estado y el perfil del asegurado.
                </p>
              </div>
            </section>

            {/* Section 4 */}
            <section data-id="element-47">
              <div className="flex items-center gap-3 mb-4" data-id="element-48">
                <ShieldCheck className="w-6 h-6 text-blue-700" data-id="element-49" />
                <h2 className="text-2xl font-bold text-slate-900" data-id="element-50">
                  4. Seguridad de sus Datos
                </h2>
              </div>
              <div className="pl-9" data-id="element-51">
                <p data-id="element-52">
                  Vidality Insurance Group implementa medidas de seguridad
                  técnicas y administrativas para proteger su información
                  personal contra acceso no autorizado, pérdida o divulgación
                  indebida.
                </p>
              </div>
            </section>

            {/* Section 5 */}
            <section data-id="element-53">
              <div className="flex items-center gap-3 mb-4" data-id="element-54">
                <UserCog className="w-6 h-6 text-blue-700" data-id="element-55" />
                <h2 className="text-2xl font-bold text-slate-900" data-id="element-56">
                  5. Sus Derechos
                </h2>
              </div>
              <div className="pl-9 space-y-4" data-id="element-57">
                <p data-id="element-58">Usted tiene derecho a:</p>
                <ul className="list-disc pl-5 space-y-2 text-slate-700 marker:text-blue-500" data-id="element-59">
                  <li data-id="element-60">Acceder a la información que tenemos sobre usted</li>
                  <li data-id="element-61">Solicitar la corrección de datos incorrectos</li>
                  <li data-id="element-62">
                    Solicitar la eliminación de sus datos en cualquier momento
                  </li>
                  <li data-id="element-63">
                    Retirar su consentimiento de comunicación cuando lo desee
                  </li>
                </ul>
                <div className="mt-6 bg-slate-50 p-5 rounded-lg border border-slate-200" data-id="element-64">
                  <p className="font-medium text-slate-900 mb-3" data-id="element-65">
                    Para ejercer cualquiera de estos derechos, contáctenos en:
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4" data-id="element-66">
                    <a href="mailto:support@vitalityinsurancegroup.com" className="flex items-center gap-2 text-blue-700 hover:text-blue-800 transition-colors" data-id="element-67">
                      <Mail className="w-5 h-5" data-id="element-68" />
                      <span className="underline decoration-blue-300 underline-offset-2" data-id="element-69">
                        support@vitalityinsurancegroup.com
                      </span>
                    </a>
                    <a href="tel:4012404418" className="flex items-center gap-2 text-blue-700 hover:text-blue-800 transition-colors" data-id="element-70">
                      <Phone className="w-5 h-5" data-id="element-71" />
                      <span className="underline decoration-blue-300 underline-offset-2" data-id="element-72">
                        (401) 240-4418
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* Section 6 */}
            <section data-id="element-73">
              <div className="flex items-center gap-3 mb-4" data-id="element-74">
                <Scale className="w-6 h-6 text-blue-700" data-id="element-75" />
                <h2 className="text-2xl font-bold text-slate-900" data-id="element-76">
                  6. Cumplimiento Legal
                </h2>
              </div>
              <div className="pl-9 space-y-4" data-id="element-77">
                <p data-id="element-78">Vidality Insurance Group opera en cumplimiento con:</p>
                <ul className="list-disc pl-5 space-y-2 text-slate-700 marker:text-blue-500" data-id="element-79">
                  <li data-id="element-80">TCPA (Telephone Consumer Protection Act)</li>
                  <li data-id="element-81">CAN-SPAM Act</li>
                  <li data-id="element-82">Regulaciones estatales de seguros aplicables</li>
                  <li data-id="element-83">Leyes de protección de datos vigentes en EE. UU.</li>
                </ul>
              </div>
            </section>
          </div>
        </article>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-8 text-center border-t border-slate-800" data-id="element-84">
        <div className="max-w-4xl mx-auto px-4 flex flex-col items-center gap-4" data-id="element-85">
          <Shield className="w-6 h-6 text-slate-600" data-id="element-86" />
          <p className="text-sm" data-id="element-87">
            &copy; {new Date().getFullYear()} Vidality Insurance Group. Todos
            los derechos reservados.
          </p>
          <div className="flex gap-6 text-sm mt-2" data-id="element-88">
            <a href="mailto:support@vitalityinsurancegroup.com" className="hover:text-white transition-colors" data-id="element-89">
              support@vitalityinsurancegroup.com
            </a>
            <a href="tel:4012404418" className="hover:text-white transition-colors" data-id="element-90">
              (401) 240-4418
            </a>
          </div>
        </div>
      </footer>
    </div>;
}